export enum CashOfficeUserActions {
  Any = 'Any',
  PaidIn = 'PaidIn',
  PaidOut = 'PaidOut',
  TenderPickup = 'TenderPickup',
  TillDeclaration = 'TillDeclaration',
  TillClosing = 'TillClosing',
  LoanAdd = 'TenderLoan',
  BlindPickup = 'BlindPickup',
}
